import React from 'react'
import { FEATURE_UC_IN_WEBREGISTER_LINE_ITEM } from '../../../../../constants'
import { getFeatureFromCache } from '../../../../../util/feature-cache'
import { LineItemFulfilmentAddress as LineItemFulfilmentAddressUnified } from './LineItemFulfilmentAddress'
import { LineItemFulfilmentAddressLegacy } from './LineItemFulfilmentAddressLegacy'
import type { LineItemFulfilmentAddressProps } from './useLineItemFulfilmentAddressModel'

export const LineItemFulfilmentAddress: React.FC<LineItemFulfilmentAddressProps> = props => {
  const isUnifiedFulfilmentUiEnabled = getFeatureFromCache(
    FEATURE_UC_IN_WEBREGISTER_LINE_ITEM
  )

  return isUnifiedFulfilmentUiEnabled ? (
    <LineItemFulfilmentAddressUnified {...props} />
  ) : (
    <LineItemFulfilmentAddressLegacy {...props} />
  )
}
